<!-- 参考模板：https://codepen.io/Chewbaccaa/project/full/DxErdn -->
<template>
  <div id="app1">
    <el-container>
      <el-aside width="70vw">
        <el-image :src="require('../assets/images/FC100watergun.png')"></el-image>
      </el-aside>
      <el-container>
        <el-header height="100vh">
          <div class="welcome">欢迎登录！</div>
          <div class="systemName">拓疆设备管理后台</div>
<!--          <div class="acco">-->
<!--          <lable class="text1">账号</lable>-->
<!--          <el-input v-model="username" placeholder="请输入内容" ></el-input>-->
<!--          </div>-->
<!--          <div class="pass">-->
<!--          <lable class="text1">密码</lable>-->
<!--          <el-input v-model="password" placeholder="请输入内容" show-password></el-input>-->
<!--          </div>-->
<!--          <div class="deng">-->
<!--            <el-button type="primary" style="width: 291px;" @click="login">登录</el-button>-->
<!--          </div>-->
          <div class="div-form">
          <el-form :model="loginForm"  :rules="rules" ref="loginForm" label-position="top" label-width="80px" class="demo-ruleForm"   >
            <el-form-item label="用户名" prop="pass">
              <el-col :span="24">
              <el-input type="text" style="width: 300px" v-model="loginForm.username" autocomplete="off"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="密码" prop="checkPass">
              <el-col :span="24">
              <el-input type="password" style="width: 300px" v-model="loginForm.password" autocomplete="off" show-password></el-input>
              </el-col>
            </el-form-item>
<!--            <el-form-item>-->
<!--              <el-col :span="24">-->
<!--                <lable class="mess-lable">{{this.message}}</lable>-->
<!--              </el-col>-->
<!--            </el-form-item>-->
            <el-form-item>
              <el-col :span="24">
              <el-button type="primary"   @click="login('loginForm')" lass="large-button">登录</el-button>
              </el-col>
            </el-form-item>
          </el-form>
          </div>
        </el-header>
      </el-container>
    </el-container>
  </div>
</template>

<script >
import axios from '../utils/request'
import router from '../router/index'
export default {
  name: 'Login',
  data: function () {
    return {
      loginForm: {
        username: '',
        password: '',
        temp_username: ''
      },
      message: ''
    }
  },
  methods: {
    // getCookie (name) {
    //   const cookies = document.cookie.split(';')
    //   for (let cookie of cookies) {
    //     const [key, value] = cookie.trim().split('=')
    //     if (key === name) {
    //       return decodeURIComponent(value)
    //     }
    //   }
    //   return null
    // },

    login: function () {
      // alert('1223')
      this.loading = true
      var that = this
      axios.post('/user/login', this.loginForm).then(function (res) {
        // localStorage.setItem('username', this.username)
        // localStorage.setItem('password', this.password)
        if (res.code === 500) {
          that.message = res.message
          router.push({
            path: '/',
            query: {
              message: that.message
            }
          })
          that.$message(that.message)
        } else if (res.code === 200) {
          localStorage.setItem('token', res.data.token)
          that.temp_username = res.data.username
          router.push({
            path: '/data/useraccount',
            query: {
              username: that.temp_username
            }
          })
        }
      }).catch(function (error) {
        console.log(error)
        router.push({
          path: '/',
          query: {
            message: that.message
          }
        })
      })
      // const token = this.getCookie('token')
      // console.log('Cookie 值:', token)
    }
  }
}

</script>

<style scoped>
  #app1 {
    position:absolute;
    top:0;
    right:0;
    bottom:0;
    left:0;
  }
  .el-container {
    height: 100vh;
  }
  .el-header {
    background-color: #ffffff;
    color: #333;
  }

  .el-aside {
    background-color: #f0f2f5;
    color: #333;
    text-align: center;
    line-height: 200px;
    /*width: 400px;*/
  }
  .welcome {
    font-size: 20px;
    color: #1a1a1a;
    text-align: left;
    margin-top: 45px;
  }
  .systemName {
    font-size: 30px;
    margin-top: 0px;
    font-weight: 700;
    color: #000;
    text-align: left;
  }

  .div-form{
  margin-top:76px;
  }
  .el-button{
    font-size: 16px;
    padding: 10px 135px;
    margin-top: 30px;
  }

</style>



// WEBPACK FOOTER //
// src/components/Login.vue